import { notify } from 'utils/reduxUtils';

export const types = {
  ACCOUNT_SEARCH_ERROR: 'common/accountSelector/ACCOUNT_SEARCH_ERROR',
  ACCOUNT_SEARCH_REQUEST: 'common/accountSelector/ACCOUNT_SEARCH_REQUEST',
  ACCOUNT_SEARCH_SUCCESS: 'common/accountSelector/ACCOUNT_SEARCH_SUCCESS',
  FETCH_ACCOUNT_REQUEST: 'common/accountSelector/FETCH_ACCOUNT_REQUEST',
  FETCH_ACCOUNT_SUCCESS: 'common/accountSelector/FETCH_ACCOUNT_SUCCESS',
  RECEIVE_ACCOUNT: 'common/accountSelector/RECEIVE_ACCOUNT',
};

export const accountSearch = {
  request: ({ search }) => ({
    type: types.ACCOUNT_SEARCH_REQUEST,
    payload: { search },
  }),
  success: ({ searchResults }) => ({
    type: types.ACCOUNT_SEARCH_SUCCESS,
    payload: { searchResults },
  }),
  error: notify(
    (error) => ({
      type: types.ACCOUNT_SEARCH_ERROR,
      payload: error,
    }),
    "Can't fetch accounts",
  ),
};

export const fetchAccount = {
  request: ({ accountId }) => ({
    type: types.FETCH_ACCOUNT_REQUEST,
    payload: { accountId },
  }),
  success: ({ account }) => ({
    type: types.FETCH_ACCOUNT_SUCCESS,
    payload: { account },
  }),
};

export const receiveAccount = {
  request: ({ account }) => ({
    type: types.RECEIVE_ACCOUNT,
    payload: { account },
  }),
};
